<script>
import appConfig from '@src/app.config'

export default {
  page: {
    title: 'Dutch GP livestream',
    meta: [{ name: 'description', content: 'Dutch GP livestream' }],
  },
  data() {
    return {
      systemUuids: appConfig.dutchGp.systemUuids,
    }
  },
  methods: {
    error(e) {
      // Retry after 5 seconds
      setTimeout(() => {
        e.target.src = e.target.src; // eslint-disable-line no-self-assign
      }, 5 * 1000);
    },
  },
}
</script>

<template>
  <div :class="$style.grid">
    <img v-for="systemUuid in systemUuids" :key="systemUuid" :src="`/stream/system/${systemUuid}/stream.jpg`"
      @error="error" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

body {
  background-color: #000;
}

.grid {
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-items: center;
  width: 100vw;
  height: 100vh;
  grid-gap: 1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
